export default {
  sessionStart: 'sessionStart',
  sessionEnd: 'sessionEnd',
  openPage: 'openPage',
  blureTab: 'blureTab',
  focusTab: 'focusTab'  
}